import React, { useState } from "react";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { Button, SxProps, Theme } from "@mui/material";
import ConfirmationDialog from "./ConfirmationDialog";

interface DeleteButtonProps {
  onRemove: (event: React.MouseEvent<HTMLButtonElement>) => void;
  messageText: string;
  sx?: SxProps<Theme>
}

export const DeleteButton: React.FC<DeleteButtonProps> = ({
  onRemove,
  messageText,
  sx
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = (e: React.MouseEvent<HTMLButtonElement>) => {
    setOpen(false);
    onRemove(e);
  };

  return (
    <>
      <Button
        onClick={handleOpen}
        variant="outlined"
        size="large"
        sx={{ ml: "1rem", py: "0.5rem", marginLeft: "auto", ...sx, width: "2rem", maxHeight: "2rem" }}
        color="error"
      >
        <DeleteIcon />
      </Button>

      <ConfirmationDialog
        open={open}
        onClose={handleClose}
        onConfirm={(e:any) => {return handleConfirm(e)}}
        title="Confirmação"
        content={messageText}
      />
    </>
  );
};
